import React from 'react'
import Buttoncomp from './form/custom-buttom'
import './cart.scss'
import { connect } from 'react-redux'
import { withRouter } from "react-router-dom";
import { CartActionType } from '../redux/action'

const CartContainer = (props) => {
    return (
        <div className={`${props.show ? '' : 'show' } cart-cont`}>
            <div className='items'>{
                props.cartitems.length?
           props.cartitems.map(
            item => (
                <div className='cart-item' key={item.id}>
                    <img src={item.imageUrl} alt='item' />
                    <div className='item-content'>
                        <span className='name'>{item.name}</span>
                        <span>{item.quantity} X ${item.price}</span>
                    </div>
                </div>
            ) 

           ): <span className='empty'>Your Cart Is Empty</span>
        
        }
            </div>
        <Buttoncomp onClick={()=> 
       { 
         props.history.push('/checkout');
         props.dispatch(CartActionType());
      }
    
    } >Go to CheckOut</Buttoncomp>

        </div>
    )

}
const map = state => ({
    cartitems : state.cart.cartItems ,
    show : state.cart.hidden

})
export default withRouter(connect(map)(CartContainer)) ; 